import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UtilService, VariablesService, VwoService } from '../../shared/services';

@Component({
  selector: 'app-mini-story',
  templateUrl: './mini-story.component.html',
  styleUrls: ['./mini-story.component.scss']
})
export class MiniStoryComponent implements OnInit {

  readonly vars = inject(VariablesService);

  @Input() fundraiser;
  isFundraiserEnded;
  @Output() viewMore = new EventEmitter();
  caller_name;
  params;

  constructor(
    public util: UtilService,
    public actRoute: ActivatedRoute,
    public vwo: VwoService
  ) { }

  ngOnInit(): void {
    this.params = this.actRoute.snapshot.queryParams;
    this.util.addCssToGlobal('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap');
    this.isFundraiserEnded = this.util.checkFundraiserEnded(this.fundraiser?.status_flag, this.fundraiser?.end_date);
    const x = this.params['utm_medium']?.indexOf('_');
    this.caller_name = this.params['utm_medium']?.substr(x + 1);
  }

  getTheaterImg() {
    if (this.params?.mini_story === '2' || this.params?.mini_story === '1') {
      return this.fundraiser?.theater?.cdn_path || this.fundraiser?.leaderboard?.cdn_path;
    } else {
      return this.fundraiser?.theater?.cdn_path;
    }
  }
}
